import { render, staticRenderFns } from "./ConsentOlympus.vue?vue&type=template&id=d45b9678&"
import script from "./ConsentOlympus.vue?vue&type=script&lang=js&"
export * from "./ConsentOlympus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports